

exports.__esModule = true;
exports.$xoPageAddCardPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-wallet-components/src/add-card/directive');

require('xo-validation/dist/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-page-components/src/value-props/directive');

require('xo-models/src/fi/lib/fiMessages');

require('xo-models/src/checkout/index');

var _squid = require('squid');

var _choice = require('xo-models/src/choice');

var _logger = require('xo-beaver/dist/logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
    tag: 'xo-page-add-card-page',
    template: _template2['default'],
    scope: {},

    controller: function controller($scope, $rootScope, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $CheckoutCartModel, $AuthModel, $fiMessages) {
        // eslint-disable-line max-params,no-shadow
        $scope.token = $rootScope.token;
        $scope.locale = $locale;
        $scope.callbacks = {
            finish: function finish() {
                $state.go('checkout.review');
            }
        };

        var models = {};

        $populate(models, {
            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            payee: $CheckoutPayeeModel.instance($scope.token),
            cart: $CheckoutCartModel.instance($scope.token),
            auth: $AuthModel.instance().retrieve()
        }).then(function () {
            (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment').then(function (result) {
                var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false);

                // If no processor decline, get the message when contingency is anything but NEED_DEBIT_CARD
                if (!message && models.checkoutSession.get('errorData.cause') && $stateParams.message !== 'NEED_DEBIT_CARD') {
                    if (models.payee.isGambling()) {
                        message = $fiMessages.getGamblingMsg();
                    } else if (result) {
                        message = $fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                    } else {
                        message = $fiMessages.getAddCardControlMsg();
                    }
                }

                $scope.message = undefined;
                $scope.cart = models.cart;
                $scope.auth = models.auth;

                if (message) {
                    $scope.message = {
                        type: message.type,
                        msgs: [message.msg]
                    };
                    if (message.title) {
                        $scope.messagetitle = $locale.content.get(message.title.key);
                    }
                }

                // Set ShowCancel if selectFi variant, to cancel to the Select Fi page
                return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                    var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                    // Show selectFi features if no contingency
                    if (selectFiVariants.indexOf(variant) !== -1 && !message) {
                        $scope.showCancel = true;
                        $scope.callbacks.cancel = function () {
                            $state.go('checkout.selectFi');
                        };
                        $scope.pagetitle = $locale.content.get('addCard.addACard');
                    }
                });
            });
        });

        $scope.isUpdateDebitCard = function () {
            return $stateParams.message === 'EXPIRED_DEBIT_CARD';
        };

        $scope.logout = function () {
            _logger.$logger.info('not_you_logout');

            if (window.xchild && _squid.$util.isIFrame()) {

                window.xchild.hide();

                var url = window.location.href.split('#')[0];

                var xprops = _extends({}, window.xprops);

                xprops.url = url;
                xprops.payment = function () {
                    return $scope.auth.action('logout').then(function () {
                        return $scope.token;
                    });
                };

                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
            }

            $scope.auth.action('logout').then(function () {
                $state.go('checkout.login', {
                    source: 'NOT_YOU'
                });
            });
        };
    }
});

angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
_squid.$Component;

_squid.$config;

_squid.$pxp;

_squid.$util;

_choice.$ChoiceEligibility;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-card/directive.js
// module id = ./pages/xo-add-card/directive.js
// module chunks = 1